module.exports = __webpack_public_path__ + "static/img_xnzf.6cba4afe.png";